// og_price "-X% Price Reduction" display.
// Kept separate from compare_at_price / slash pricing on purpose: this only
// reads the per-variant percentages rendered by snippets/og-price-percent.liquid.
(function () {
  function update(productId, variant) {
    var els = document.querySelectorAll('[data-og-reduced][data-product-id="' + productId + '"]');

    Array.prototype.forEach.call(els, function (el) {
      var percents = {};
      try {
        percents = JSON.parse(el.getAttribute('data-og-percents') || '{}');
      } catch (e) {}

      var pct = variant ? percents[variant.id] : null;
      var output = el.querySelector('[data-og-reduced-percent]');

      if (pct) {
        output.textContent = `-${pct}%`;
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
  }

  // The theme's OptionSelectors call window.selectCallback on every variant
  // change, so wrap it rather than editing the minified app.js.
  function wrapSelectCallback() {
    var original = window.selectCallback;
    if (typeof original !== 'function' || original.__ogPrice) return;

    var wrapped = function (variant, selector) {
      var result = original.apply(this, arguments);
      try {
        update(selector.product.id, variant);
      } catch (e) {}
      return result;
    };
    wrapped.__ogPrice = true;
    window.selectCallback = wrapped;
  }

  wrapSelectCallback();
  document.addEventListener('DOMContentLoaded', wrapSelectCallback);
})();
